import Accountant from "./career-tiles/small/accountant.jpg";
import Acting from "./career-tiles/small/acting.jpg";
import Aeronautical from "./career-tiles/small/aeronautical-eng.jpg";
import AirTrafficController from "./career-tiles/small/air-traffic-control.jpg";
import AnimalAttendant from "./career-tiles/small/animal-attendant.jpg";
import Animator from "./career-tiles/small/animator.jpg";
import ArchitectureDraft from "./career-tiles/small/architecture-draft.jpg";
import Architecture from "./career-tiles/small/architecture.jpg";
import Archeologist from "./career-tiles/small/arrcheologist.jpg";
import Artist from "./career-tiles/small/artist.jpg";
import Astronomer from "./career-tiles/small/astronomer.jpg";
import Bar from "./career-tiles/small/bar.jpg";
import Beauty from "./career-tiles/small/beauty.jpg";
import Bricklayer from "./career-tiles/small/bricklayer.jpg";
import Builder from "./career-tiles/small/builder.jpg";
import CabinetMaker from "./career-tiles/small/cabinet-maker.jpg";
import CameraOperator from "./career-tiles/small/camera-operator.jpg";
import Carpenter from "./career-tiles/small/carpenter.jpg";
import Chef from "./career-tiles/small/chef.jpg";
import ChildCare from "./career-tiles/small/child-care.jpg";
import Chiro from "./career-tiles/small/chiro.jpg";
import CivilEngineer from "./career-tiles/small/civ-eng.jpg";
import Concierge from "./career-tiles/small/concierge.jpg";
import Councillor from "./career-tiles/small/councillor.jpg";
import Criminologist from "./career-tiles/small/criminologist.jpg";
import Dance from "./career-tiles/small/dance.jpg";
import DentalTech from "./career-tiles/small/dental-tech.jpg";
import Dentist from "./career-tiles/small/dental.jpg";
import DieselMech from "./career-tiles/small/diesel-mech.jpg";
import Dietitian from "./career-tiles/small/dietitian.jpg";
import DigitalMedia from "./career-tiles/small/digial-media.jpg";
import Electrician from "./career-tiles/small/electrician.jpg";
import ElectronicEng from "./career-tiles/small/electronic-eng.jpg";
import EnvironmentalSci from "./career-tiles/small/env.jpg";
import EventPlanner from "./career-tiles/small/event.jpg";
import Farming from "./career-tiles/small/farming.jpg";
import Fashion from "./career-tiles/small/fashion.jpg";
import FilmDirector from "./career-tiles/small/film-director.jpg";
import FireFighter from "./career-tiles/small/fire-fighter.jpg";
import Fitness from "./career-tiles/small/fitness.jpg";
import FlightAttendant from "./career-tiles/small/flight-attendant.jpg";
import Forensic from "./career-tiles/small/forensic.jpg";
import Freight from "./career-tiles/small/freight.jpg";
import GamesDev from "./career-tiles/small/games-dev.jpg";
import GeneralPrac from "./career-tiles/small/gp.jpg";
import GraphicDesign from "./career-tiles/small/graphic.jpg";
import Hairdresser from "./career-tiles/small/hair-dresser.jpg";
import Historian from "./career-tiles/small/historian.jpg";
import HotelManager from "./career-tiles/small/hotel-manager.jpg";
import IndustrialDesigner from "./career-tiles/small/industrial-design.jpg";
import InteriorDesign from "./career-tiles/small/interior-design.jpg";
import IT from "./career-tiles/small/it.jpg";
import Journalist from "./career-tiles/small/journalist.jpg";
import Landscape from "./career-tiles/small/landscape.jpg";
import LabTech from "./career-tiles/small/latb-tech.jpg";
import LawClerk from "./career-tiles/small/law-clerk.jpg";
import Lawyer from "./career-tiles/small/lawyer.jpg";
import Locksmith from "./career-tiles/small/locksmit.jpg";
import Marketing from "./career-tiles/small/marketing.jpg";
import Mechanic from "./career-tiles/small/mechanic.jpg";
import MechanicalEng from "./career-tiles/small/mechanical-eng.jpg";
import MechatronicEng from "./career-tiles/small/mechatronic-eng.jpg";
import MedicalSci from "./career-tiles/small/medical-sci.jpg";
import MetalFab from "./career-tiles/small/metal-fab.jpg";
import Midwife from "./career-tiles/small/midwife.jpg";
import Mining from "./career-tiles/small/mining.jpg";
import Museum from "./career-tiles/small/museum.jpg";
import Musician from "./career-tiles/small/musician.jpg";
import Navy from "./career-tiles/small/navy.jpg";
import NurseEnrolled from "./career-tiles/small/nurse-enrolled.jpg";
import Nurse from "./career-tiles/small/nurse.jpg";
import OccTherapy from "./career-tiles/small/occ-therapy.jpg";
import OfficeClerk from "./career-tiles/small/office-clerk.jpg";
import Optomotrist from "./career-tiles/small/optomotrist.jpg";
import PanelBeater from "./career-tiles/small/panel-beater.jpg";
import Paramedic from "./career-tiles/small/paramedic.jpg";
import ParkRanger from "./career-tiles/small/park-ranger.jpg";
import PetGroomer from "./career-tiles/small/pet-groomer.jpg";
import Pharmacist from "./career-tiles/small/pharmacist.jpg";
import Photographer from "./career-tiles/small/photographer.jpg";
import Physio from "./career-tiles/small/physio.jpg";
import Pilot from "./career-tiles/small/pilot.jpg";
import Plumber from "./career-tiles/small/plumber.jpg";
import Police from "./career-tiles/small/police.jpg";
import PrimaryTeacher from "./career-tiles/small/primary-teacher.jpg";
import Printer from "./career-tiles/small/printer.jpg";
import Pysch from "./career-tiles/small/psych.jpg";
import Radiographer from "./career-tiles/small/radiographer.jpg";
import RealEstate from "./career-tiles/small/real-estate.jpg";
import Refridgeration from "./career-tiles/small/refridgeration-mech.jpg";
import Retail from "./career-tiles/small/retail.jpg";
import SecondaryTeacher from "./career-tiles/small/secondary-teacher.jpg";
import Security from "./career-tiles/small/security.jpg";
import ShopFitter from "./career-tiles/small/shop-fitter.jpg";
import SignWriter from "./career-tiles/small/sign-writer.jpg";
import SocailWorker from "./career-tiles/small/social-worker.jpg";
import Soldier from "./career-tiles/small/soilder.jpg";
import SoundTech from "./career-tiles/small/sound-tech.jpg";
import SpeechPath from "./career-tiles/small/speech-path.jpg";
import Sport from "./career-tiles/small/sport.jpg";
import Surveyor from "./career-tiles/small/surveyor.jpg";
import Tiler from "./career-tiles/small/tiler.jpg";
import ToolMaking from "./career-tiles/small/tool-making.jpg";
import TownPlanner from "./career-tiles/small/town-planner.jpg";
import Translator from "./career-tiles/small/translator.jpg";
import TravelAgent from "./career-tiles/small/travel-agent.jpg";
import VetNurse from "./career-tiles/small/vet-nurse.jpg";
import Vet from "./career-tiles/small/vet.jpg";
import WebDesign from "./career-tiles/small/web-design.jpg";
import Writer from "./career-tiles/small/writer.jpg";
import Zoo from "./career-tiles/small/zoo.jpg"; 
import Agriculture from "./atar-category/agriculture.jpg";
import ArchitectureCat from "./atar-category/architecture.jpg";
import Arts from "./atar-category/arts.jpg";
import Business from "./atar-category/business.jpg";
import Creative from "./atar-category/creative.jpg";
import Edu from "./atar-category/education.jpg";
import Engineering from "./atar-category/engineering.jpg";
import Environmental from "./atar-category/environmental.jpg";
import Health from "./atar-category/health.jpg";
import ITCat from "./atar-category/it.jpg";
import Law from "./atar-category/law.jpg";
import Tourism from "./atar-category/tourism.jpg"; 
import Chemical from "./additional-category-images/chemical.jpg";
import Food from "./additional-category-images/food-sci.jpg";
import Mechanical from "./additional-category-images/mechanical.jpg";
import Paper from "./additional-category-images/paper.jpg";
import Textiles from "./additional-category-images/textiles.jpg"
import Transport from "./additional-category-images/transport.jpg"
import Wood from "./additional-category-images/wood.jpg"

const CareerImagesSmall : {[k:string]:string} = {
    "ACCOUNTANT" : Accountant,
    "ACTOR" : Acting,
    "AERONAUTICAL MECHANIC" : Aeronautical,
    "AIR TRAFFIC CONTROLLER" : AirTrafficController,
    "ANIMAL ATTENDANT" : AnimalAttendant,
    "ANIMATOR" : Animator,
    "ARCHAEOLOGIST" : Archeologist,
    "ARCHITECT" : Architecture,
    "ARCHITECT DRAFTER" : ArchitectureDraft,
    "ARTIST" : Artist,
    "ASTRONOMER" : Astronomer,
    "BARISTA & DRINKS" : Bar,
    "BEAUTY THERAPIST" : Beauty,
    "BRICKLAYER" : Bricklayer,
    "BUILDER" : Builder,
    "CABINETMAKER" : CabinetMaker,
    "CAMERA OPERATOR" : CameraOperator,
    "CARPENTER" : Carpenter,
    "CHEF" : Chef,
    "CHILDCARE WORKER" : ChildCare,
    "CHIROPRACTOR" : Chiro,
    "CIVIL ENGINEER" : CivilEngineer,
    "CONCIERGE" : Concierge,
    "COUNSELLOR" : Councillor,
    "CRIMINOLOGIST" : Criminologist,
    "DANCE" : Dance,
    "DENTAL TECHNICIAN" : DentalTech,
    "DENTIST" : Dentist,
    "DIESEL MECHANIC" : DieselMech,
    "DIETITIAN" : Dietitian,
    "DIGITAL MEDIA" : DigitalMedia,
    "ELECTRICIAN" : Electrician,
    "ELECTRICAL ENGINEER" : ElectronicEng,
    "ENVIRONMENT" : EnvironmentalSci,
    "EVENTS" : EventPlanner,
    "FARMING & AGRICULTURE" : Farming,
    "FASHION" : Fashion,
    "FILM DIRECTOR" : FilmDirector,
    "FIREFIGHTER" : FireFighter,
    "FITNESS" : Fitness,
    "FLIGHT ATTENDANT" : FlightAttendant,
    "FORENSICS" : Forensic,
    "FREIGHT & LOGISTICS" : Freight,
    "GAMES DESIGNER" : GamesDev,
    "MEDICINE" : GeneralPrac,
    "GRAPHIC DESIGNER" : GraphicDesign,
    "HAIRDRESSER" : Hairdresser,
    "HISTORIAN" : Historian,
    "HOTEL MANAGER" : HotelManager,
    "INDUSTRIAL DESIGNER" : IndustrialDesigner,
    "INTERIOR DESIGNER" : InteriorDesign,
    "COMPUTING & IT" : IT,
    "JOURNALIST" : Journalist,
    "LABORATORY ASSISTANT/TECHNICIAN" : LabTech,
    "LANDSCAPER" : Landscape,
    "LAW CLERK" : LawClerk,
    "LAWYER" : Lawyer,
    "LOCKSMITH" : Locksmith,
    "MARKETING" : Marketing,
    "MECHANIC" : Mechanic,
    "MECHANICAL ENGINEER" : MechanicalEng,
    "MECHATRONIC ENGINEER" : MechatronicEng,
    "MEDICAL SCIENTIST" : MedicalSci,
    "METAL FABRICATOR" : MetalFab,
    "MIDWIFE" : Midwife,
    "MINING" : Mining,
    "MUSEUM CURATOR" : Museum, 
    "MUSICIAN" : Musician,
    "NAVY" : Navy,
    "NURSING" : Nurse,
    "NURSING ENROLLED" : NurseEnrolled,
    "OCCUPATIONAL THERAPIST" : OccTherapy,
    "OFFICE CLERK" : OfficeClerk,
    "OPTOMETRIST" : Optomotrist,
    "PANEL BEATER" : PanelBeater,
    "PARAMEDIC" : Paramedic,
    "PARK RANGER" : ParkRanger,
    "PET GROOMER" : PetGroomer,
    "PHARMACIST" : Pharmacist,
    "PHOTOGRAPHER" : Photographer,
    "PHYSIOTHERAPIST" : Physio,
    "PILOT" : Pilot,
    "PLUMBER" : Plumber,
    "POLICE OFFICER (STATE)" : Police,
    "PRIMARY TEACHER" : PrimaryTeacher,
    "PRINTER" : Printer,
    "PSYCHOLOGY" : Pysch,
    "RADIOGRAPHER" : Radiographer,
    "REAL ESTATE" : RealEstate,
    "REFRIGERATION MECHANIC" : Refridgeration,
    "RETAIL" : Retail,
    "SECONDARY TEACHER" : SecondaryTeacher,
    "SECURITY OFFICER" : Security,
    "SHOP FITTER" : ShopFitter,
    "SIGNWRITER" : SignWriter,
    "SOCIAL WORKER" : SocailWorker,
    "ARMY" : Soldier,
    "SOUND TECHNICIAN" : SoundTech,
    "SPEECH PATHOLOGIST" : SpeechPath,
    "SPORT AND RECREATION" : Sport,
    "SURVEYOR" : Surveyor,
    "TILER" : Tiler,
    "TOOL MAKER" : ToolMaking,
    "TOWN PLANNER" : TownPlanner,
    "TRANSLATOR" : Translator,
    "TRAVEL" : TravelAgent,
    "VET" : Vet,
    "VETERINARY NURSE" : VetNurse,
    "WEB DESIGNER" : WebDesign,
    "WRITER" : Writer,
    "ZOOLOGIST" :  Zoo,
    "AGRICULTURE, ANIMAL AND PRIMARY INDUSTRIES": Agriculture,
    "ARCHITECTURE, BUILDING, CONSTRUCTION AND PLANNING": ArchitectureCat,
    "ART, DESIGN, MUSIC AND ENTERTAINMENT": Creative,
    "BUSINESS, ADMINISTRATION AND SALES": Business,
    "CHEMICAL AND MATERIALS": Chemical,
    "COMPUTING AND INFORMATION TECHNOLOGY": ITCat,
    "EDUCATION": Edu,
    "ENGINEERING AND TECHNICAL": Engineering,
    "FOOD PRODUCTION": Food,
    "FURNITURE AND WOOD":Wood,
    "HEALTH, MEDICINE, COMMUNITY AND BEAUTY": Health,
    "HOSPITALITY AND TOURISM": Tourism,
    "LAW, POLICING AND DEFENCE": Law,
    "LITERATURE, ARTS AND SOCIAL SCIENCE": Arts,
    "METAL, ELECTRICAL AND AUTOMOTIVE": Mechanical,
    "SCIENCE AND MATHEMATICS": Environmental,
    "PRINTING AND PAPER": Paper,
    "TEXTILES, CLOTHING AND FOOTWEAR": Textiles,
    "TRANSPORT AND STORAGE": Transport,
};

export default CareerImagesSmall;